// 需登入才可進入的頁面：在頁面加上 definePageMeta({ middleware: 'auth' })
// 登入入口是全站共用的登入彈窗（沒有登入頁），因此未登入時回首頁並把彈窗打開。
// 註：SSR 直接開網址時是 HTTP 轉址，重新渲染會丟掉這個狀態，只會單純回到首頁。
export default defineNuxtRouteMiddleware((to) => {
  const { isLogged } = useAuth()
  if (isLogged.value) return

  const { openLogin } = useLoginDialog()
  openLogin(to.fullPath)
  return navigateTo('/', { replace: true })
})
